import React from 'react'
import styled from 'styled-components'
import { Link, withRouter } from 'react-router-dom'

import { textTranslation, shouldTranslateTo } from '../utils/utils'

import { Title, Subtitle, Button, FlexRow } from './Utils/CustomClassesV2'

const Container = styled.div`
  background-color: #fff;
  margin-top: 40px;

  @media screen and (max-width: 980px) {
    margin-top: 120px;
  }

  @media screen and (max-width: 768px) {
    margin-top: 65px;
  }

  @media screen and (max-width: 767px) {
    margin-top: -15px;
  }
`

const FlexRowUneven = styled.div`
  display: flex;
  flex-direction: row;
  /* flex-wrap: wrap; */

  > :first-child {
    width: 35%;
  }

  > :last-child {
    width: 65%;
  }

  @media only screen and (max-width: 600px) {
    flex-wrap: wrap;
    flex-direction: column;
    gap: 50px;
    > div {
      width: 100% !important;
      text-align: center;
    }
  }
`

const Section = styled.div`
  padding: 74px 8vw 74px 8vw;
  ${({ backgoundColor }) =>
    backgoundColor && `background-color: ${backgoundColor};`}

  @media only screen and (max-width: 1024px) {
    padding: 74px 7vw 74px 7vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 48px 5vw 60px 5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 48px 8vw 60px 8vw !important;
  }
`

const SectionText = styled.div`
  &:first-of-type {
    margin: 0 7vw 0 0;

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: 0 0 0 5vw;

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const Box = styled.div`
  background-color: #154549;
  padding: 30px 40px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 600px) {
    padding: 25px 30px;
    margin-left: -20px;
    margin-right: -20px;
    width: calc(100% + 40px) !important;
  }
`

const List = styled.ul`
  /* list-style-position: outside; */
  margin-left: 20px;
  li {
    color: #fff;
    font-family: 'Open Sans', sans-serif !important;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 153%; /* 27.54px */
    list-style-type: disc;
    list-style-position: outside;
    margin-bottom: 10px;

    @media only screen and (max-width: 1280px) {
      font-size: 16px;
    }
  }
`

const CustomButton = styled(Button)`
  bottom: 0;
  width: 100%;
  padding: 18px 10px;
  margin-top: 60px;

  @media only screen and (max-width: 980px) {
    padding: 15px 10px;
  }

  a {
    padding: 0;
    font-size: 18px;
    height: auto;
    font-style: normal;
    font-weight: 700;
    line-height: 68%; /* 12.24px */
    letter-spacing: -0.18px;
  }
`

const CenterImage = styled.div`
  img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) and (min-width: 769px) {
    text-align: center;
    margin-bottom: 30px;
    img {
      max-width: 380px;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 50px;
  }
`

const CenterDiv = styled.div`
  text-align: center;
  margin: 0 auto;

  width: 80%;

  @media only screen and (max-width: 980px) {
    width: 100%;
  }

  button {
    padding: 15px 70px;

    a {
      padding: 0;
      font-size: 18px;
      height: auto;
      font-style: normal;
      font-weight: 700;
      line-height: 68%; /* 12.24px */
      letter-spacing: -0.18px;
    }
  }
`

const BackgroundSection = styled(Section)`
  position: relative;
  background: rgba(39, 70, 83, 1);

  &::before {
    background: rgba(39, 70, 83, 1);
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('/images/homestays/bk.png');
    background-size: cover;
    background-blend-mode: multiply;
    opacity: 0.15;
    z-index: 0;

    @media only screen and (max-width: 600px) {
      background-size: inherit;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('/images/homestays/quotes.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-blend-mode: multiply;
    z-index: 0;

    @media only screen and (max-width: 600px) {
      text-align: center;
      padding-right: 0;
      width: 250px;
    }
  }
  & > div {
    position: relative;
    z-index: 4;
  }
`

const CustomFontSubtitle = styled(Subtitle)`
  font-family: 'all-round-gothic';
`

const TestimonialImage = styled.div`
  text-align: end;
  padding-right: 50px;

  @media only screen and (max-width: 600px) {
    text-align: center;
    padding-right: 0;
  }
  img {
    border-radius: 0px 40px;
    max-width: 200px;
    width: 100%;
    box-shadow: -25px 25px #0f2732;
  }
`

const CustomRemoveSubtitle = styled(Subtitle)`
  @media only screen and (max-width: 600px) {
    br {
      display: none;
    }
  }
`

const Homestays = () => {
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homestays', language)
  }, [])
  return (
    <Container>
      <Section>
        <FlexRow>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              marginmd="0 0 20px 0"
              size="3.5vw"
              sizemd="2.5vw"
              sizesm="1.8rem"
              dangerouslySetInnerHTML={{ __html: pageText[0] }}
            />
            <Subtitle
              color="#154549"
              margin="0 0 20px 0"
              size="24px"
              sizemd="1.5rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[1] }}
            />
            <Subtitle
              color="#154549"
              size="20px"
              sizemd="1.2rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[2] }}
            />
          </SectionText>
          <Box>
            <div>
              <Subtitle
                color="#fff"
                size="26px"
                sizemd="1.6rem"
                sizesm="22px"
                margin="0 0 50px 0"
                dangerouslySetInnerHTML={{ __html: pageText[3] }}
              />
              <List>
                <li>{pageText[4]}</li>
                <li>{pageText[5]}</li>
                <li>{pageText[6]}</li>
                <li>{pageText[7]}</li>
                <li>{pageText[8]}</li>
              </List>
            </div>
            <CustomButton>
              <Link to="/search?seeking=homestays">{pageText[9]}</Link>
            </CustomButton>
          </Box>
        </FlexRow>
      </Section>
      <Section backgoundColor="#F5F8FA">
        <FlexRow>
          <CenterImage>
            <img src="/images/homestays/homestays.png" alt="Homestay" />
          </CenterImage>
          <SectionText>
            <Subtitle
              color="#154549"
              margin="0 0 30px 0"
              marginmd="0 0 30px 0"
              size="24px"
              sizemd="1.5rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[10] }}
            />
            <Subtitle
              color="#154549"
              margin="0 0 0 0"
              size="20px"
              sizemd="1.25rem"
              dangerouslySetInnerHTML={{ __html: pageText[11] }}
            />
          </SectionText>
        </FlexRow>
      </Section>
      <Section>
        <CenterDiv>
          <Title
            center
            color="#154549"
            margin="0 0 30px 0"
            size="1.5rem"
            sizemd="1.5rem"
            sizesm="23px"
            dangerouslySetInnerHTML={{ __html: pageText[12] }}
          />
          <CustomRemoveSubtitle
            center
            color="#154549"
            margin="0 0 30px 0"
            size="1.5rem"
            sizemd="1.5rem"
            sizesm="23px"
            dangerouslySetInnerHTML={{ __html: pageText[13] }}
          />
          <Subtitle
            center
            color="#154549"
            margin="0 0 30px 0"
            size="1.25rem"
            sizemd="1.25rem"
            dangerouslySetInnerHTML={{ __html: pageText[14] }}
          />
          <Button wider>
            <Link to="/search?seeking=homestays">{pageText[15]}</Link>
          </Button>
        </CenterDiv>
      </Section>
      <BackgroundSection>
        <FlexRowUneven>
          <TestimonialImage>
            <img src="/images/homestays/geraldine.png" alt="Geraldine" />
          </TestimonialImage>
          <div>
            <Subtitle
              color="#fff"
              size="26px"
              sizemd="1rem"
              sizesm="18px"
              margin="0 0 30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[16] }}
            />
            <CustomFontSubtitle
              color="#F4A261"
              size="22px"
              sizemd="1rem"
              sizesm="18px"
              margin="0 0 5px 0"
              dangerouslySetInnerHTML={{ __html: pageText[17] }}
            />
            <Subtitle
              color="#ffffff"
              size="16px"
              sizemd="1rem"
              sizesm="18px"
              margin="0 0 0 0"
              dangerouslySetInnerHTML={{ __html: pageText[18] }}
            />
          </div>
        </FlexRowUneven>
      </BackgroundSection>
    </Container>
  )
}

export default Homestays
